app.service('orderUtils', function (loading, console, broker, ajaxOrder, front) {
	function send(action, ajax) {
		var $form = $('#container form:eq(0)');
		
		$('#F_ACTION', $form).val(action);
		loading.start();
		requestAnimationFrame(function () {
			if (ajax) {
				broker.trigger('SUBMIT_BASKET_VIEW');
			} else {
				if (testAB.getVar('ajax-order') === 'B' && front.getParam('ajaxOrder')) {
					ajaxOrder.setForm($form);
					console.log('WYSŁANIE AJAXOWEGO FORMULARZA');
				} else {
					console.log('WYSŁANIE FORMULARZA');
				}
				$form.submit();
			}
		});
	}
	function back() {
		console.log('POWRÓT');
		$('input, select, textarea').ignore(true);
		send('BACK');
	}
	return {
		send: send,
		back: back
	};
});
